<template>
  <agreement-pollbox :title="'누가 섭취하시나요?'">
    <div class="form_agree-wrap">
      <div class="form_group-element">
        <span
          class="form_element-radio"
          v-for="(content, index) in intakerContents"
          :key="index"
        >
          <input
            :id="`intaker${index}`"
            v-model="selectedIntakerCode"
            type="radio"
            name="check_intaker"
            :value="content.code"
          />
          <label :for="`intaker${index}`">
            <div class="rdo_img">{{ content.name }}</div>
          </label>
        </span>
      </div>
    </div>
    <div class="check_age">
      <ul>
        <li v-for="(content, index) in ageContents" :key="index">
          <input
            :id="`age${index}`"
            v-model="selectedAgeCode"
            type="radio"
            name="check_age"
            :value="content.code"
          />
          <label :for="`age${index}`">
            <div class="rdo_img">{{ content.name }}</div>
          </label>
        </li>
      </ul>
    </div>
  </agreement-pollbox>
</template>
<script>
import AgreementPollbox from "./AgreementPollbox.vue";

export default {
  name: "AgreementPollboxAge",
  components: {
    AgreementPollbox,
  },
  props: {
    selectedIntaker: {
      type: String,
      default: "본인",
    },
    selectedAge: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedIntakerCode: this.selectedIntaker,
      selectedAgeCode: this.selectedAge,
      intakerContents: [
        {
          name: "본인",
          code: "본인",
        },
        {
          name: "본인 외",
          code: "본인 외",
        },
      ],
      ageContents: [
        {
          name: "어린이",
          code: "어린이",
        },
        {
          name: "청소년",
          code: "청소년",
        },
        {
          name: "20~30대",
          code: "2030",
        },
        {
          name: "40대",
          code: "40",
        },
        {
          name: "50대 이상",
          code: "50이상",
        },
        {
          name: "임신/수유부",
          code: "임신/수유부",
        },
      ],
    };
  },
  mounted() {
    if (!this.selectedIntakerCode) {
      //this.selectedIntakerCode = this.intakerContents[0].code;
    }
  },
  watch: {
    selectedIntakerCode(newVal) {
      this.$emit("update-intaker", newVal);
    },
    selectedAgeCode(newVal) {
      this.$emit("update-age", newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/agreement/main/partial/AgreementPollboxAge.vue